import React from 'react'

// Components
import IconDataTable from '../Icons/IconDataTable/IconDataTable';

type EmptyDataTableProps = {
  className?: string;
  text?: string;
}

const EmptyDataTable: React.FC<EmptyDataTableProps> = ({ className, text = 'NO DATA AVAILABLE' }) => {

  return (
    <div className={`c-empty-data-table flex items-center justify-center flex-col gap-y-2 font-bold py-8 ${className}`}>
      <IconDataTable width="100%" height="102%" iconClassName="max-w-18" />
      <p className='text-lg'>{text}</p>
    </div>
  )
};

export default EmptyDataTable;
